import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-261af340"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-doubts" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Tire sua dúvida referente a esta aula", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentDoubtsForm = _resolveComponent("ContentDoubtsForm")!
  const _component_ContentDoubtsList = _resolveComponent("ContentDoubtsList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ContentDoubtsForm),
    _createVNode(_component_ContentDoubtsList)
  ]))
}